"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Used as default primary color
 * Palette is taken from mnemonics design manual and are based on the mnemonic
 * black
 * All palettes are created using
 * https://material.io/design/color/the-color-system.html#tools-for-picking-colors
 */
const Black = {
    50: "#F7F7F7",
    100: "#EEEEEE",
    200: "#E3E3E3",
    300: "#D1D1D1",
    400: "#ACACAC",
    500: "#8B8B8B",
    600: "#646464",
    700: "#333333",
    800: "#131313",
    900: "#000000",
    A100: "#ACACAC",
    A200: "#646464",
    A400: "#131313",
    A700: "#000000",
};
exports.default = Black;
